import React, { useEffect } from "react";
import SmartImage from "@/components/SmartImage";

export default function Lightbox({ artwork, onClose }) {
    useEffect(() => {
        const onEsc = (e) => { if (e.key === "Escape") onClose(); };
        document.addEventListener("keydown", onEsc);
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onEsc);
            document.body.style.overflow = "";
        };
    }, [onClose]);

    if (!artwork) return null;

    const ytId = artwork.video_url?.match(/v=([^&]+)/)?.[1];

    return (
        <div
            data-testid="lightbox"
            className="fixed inset-0 z-[100] backdrop-blur-2xl flex items-center justify-center p-4 md:p-12 animate-fade-up"
            style={{ backgroundColor: "var(--bg)" }}
            onClick={onClose}
        >
            <button
                data-testid="lightbox-close"
                onClick={onClose}
                className="absolute top-6 right-6 text-bone-50 text-3xl serif hover:text-gilt transition-colors"
                aria-label="Fermer"
            >
                ×
            </button>

            <div
                className="grid md:grid-cols-5 gap-8 md:gap-16 max-w-6xl w-full max-h-[90vh]"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="md:col-span-3 flex items-center justify-center bg-ink-900 overflow-hidden">
                    <SmartImage
                        src={artwork.image_url}
                        videoUrl={artwork.video_url}
                        alt={artwork.title}
                        className="w-full h-full object-contain max-h-[80vh]"
                        fallback={artwork.title}
                    />
                </div>
                <div className="md:col-span-2 flex flex-col justify-center">
                    <div className="overline mb-3">{artwork.category}</div>
                    <h2 className="serif text-4xl md:text-5xl leading-tight mb-6">{artwork.title}</h2>
                    {artwork.medium && (
                        <p className="text-sm text-bone-300 mb-2 italic-serif">{artwork.medium}{artwork.year ? ` · ${artwork.year}` : ""}</p>
                    )}
                    {artwork.description && (
                        <p className="text-bone-200 leading-relaxed mb-8">{artwork.description}</p>
                    )}
                    {ytId && (
                        <div className="aspect-video bg-ink-900 mb-6">
                            <iframe
                                src={`https://www.youtube.com/embed/${ytId}`}
                                title={artwork.title}
                                className="w-full h-full"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
